module.exports = __webpack_public_path__ + "static/media/shutterstock_326698985.0.deda2e65.jpg";